<div class="header-container">
  <app-mid-icon-button (action)="onClose($event)" type="primary">
    <i class="fas fa-times"></i>
  </app-mid-icon-button>
  <div class="header">{{ text }}</div>
</div>
